module.exports = __webpack_public_path__ + "img/logo4.66f268e6.png";